import type { Tables } from '@/integrations/supabase/types';

export type Profile = Tables<'profiles'>;

export interface UpdateProfileInput {
  preferredName?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  email?: string;
  mobilePhone?: string;
  dateOfBirth?: string; // ISO date string
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  avatarUrl?: string;
  weeklyHours?: number | null; // Phase 5: Contract field
  fte?: number; // Phase 5: Full-time equivalent
}

export interface ProfileFormData {
  preferredName: string;
  firstName: string;
  lastName: string;
  address: string;
  email: string;
  mobilePhone: string;
  dateOfBirth: string;
  emergencyContactName: string;
  emergencyContactPhone: string;
  weeklyHours?: number | null; // Phase 5: Contract field
  fte?: number; // Phase 5: Full-time equivalent
}

// Avatar upload types
export interface AvatarUploadOptions {
  maxSizeBytes?: number;
  allowedTypes?: string[];
  quality?: number;
}

export interface AvatarUploadResult {
  url: string;
  path: string;
  size: number;
}

export const DEFAULT_AVATAR_OPTIONS: AvatarUploadOptions = {
  maxSizeBytes: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  quality: 0.8,
};
